module.exports = __webpack_public_path__ + "img/Logo_BIG.d89b2688.jpeg";